import markdown from '@wcj/markdown-to-html';

import { Accordion, Container } from '@/atoms';
import { FaqBlock, Prose } from '@/molecules';

import { routes } from '@/lib';
import {
  blockSpacing,
  eyebrowClass,
  sectionBgProps,
  textStyleClass,
} from '@/utils';

// Los `li` de Prose fuerzan body-m por CSS module (unlayered, gana a las
// utilities): dentro de un FAQ deben heredar el tamaño del resto de la
// respuesta, de ahí el `!`.
const FaqAnswer = (respuesta?: string | null) =>
  respuesta ? (
    <Prose
      html={markdown(respuesta).toString()}
      className="[&_li]:text-[length:inherit]! [&_li]:leading-[inherit]!"
    />
  ) : null;

/**
 * ComponentRevisadasPreguntasFrequentes
 * Default = layout legacy (h1 + acordeones blancos).
 * `composedLayout` (CMS toggle) = rediseño Figma HoM vía `FaqBlock`.
 */
export const ComponentRevisadasPreguntasFrequentes = ({
  pregunta_frecuentes,
  Eyebrow,
  Titulo,
  Subtitulo,
  EyebrowEstilo,
  TituloEstilo,
  SubtituloEstilo,
  AcordeonTituloEstilo,
  AcordeonRespuestaEstilo,
  EnlaceEstilo,
  composedLayout,
  MostrarEnlace,
  FondoSeccion,
  Espaciado,
}: any) => {
  if (!pregunta_frecuentes?.length) return null;
  const accordionTitleStyleClass = textStyleClass(AcordeonTituloEstilo);
  const accordionDescriptionStyleClass = textStyleClass(
    AcordeonRespuestaEstilo,
  );
  const linkStyleClass = textStyleClass(EnlaceEstilo);

  if (composedLayout) {
    const accordions = pregunta_frecuentes.map((itm: any) => ({
      title: itm.Pregunta,
      description: FaqAnswer(itm.Respuesta),
    }));

    return (
      <Container
        wrapper
        className={blockSpacing(Espaciado, '')}
        {...sectionBgProps(FondoSeccion)}
      >
        <FaqBlock
          eyebrow={Eyebrow}
          title={Titulo}
          subtitle={Subtitulo}
          eyebrowStyleClass={eyebrowClass(EyebrowEstilo)}
          titleStyleClass={textStyleClass(TituloEstilo)}
          subtitleStyleClass={textStyleClass(SubtituloEstilo)}
          accordions={accordions}
          link={
            MostrarEnlace === false
              ? undefined
              : {
                  label: 'Ver todas las preguntas frecuentes',
                  href: routes.faqs,
                }
          }
          accordionTitleStyleClass={accordionTitleStyleClass}
          accordionDescriptionStyleClass={accordionDescriptionStyleClass}
          linkStyleClass={linkStyleClass}
        />
      </Container>
    );
  }

  return (
    <Container
      wrapper
      className={blockSpacing(Espaciado, '')}
      {...sectionBgProps(FondoSeccion)}
    >
      <h1 className="mb-6">{Titulo}</h1>

      <div className="flex flex-col gap-6">
        {pregunta_frecuentes.map((itm: any, index: number) => (
          <Accordion
            key={`faq-${index}`}
            title={itm.Pregunta}
            variant="normal"
            color="white"
            titleStyleClass={accordionTitleStyleClass}
            descriptionStyleClass={accordionDescriptionStyleClass}
          >
            {FaqAnswer(itm.Respuesta)}
          </Accordion>
        ))}
      </div>
    </Container>
  );
};

ComponentRevisadasPreguntasFrequentes.displayName =
  'ComponentRevisadasPreguntasFrequentes';
